import { useTranslation } from 'react-i18next';
import React, { useState, useMemo, useRef } from 'react';
import Style from './style';
import Widget from '../../widget';
import useMapHelper from './hook';
import { getMineSiteDetailsConfig } from './config';
import Documentation from '../../../../components/dashboards/components/OverviewMap/Documentation';
import OverviewMapControllers from '../../../../components/dashboards/components/OverviewMap/Controllers';

export default function Overview({
  data = {},
  mod,
  mode = 'tif',
}) {
  const container = useRef();
  const { t } = useTranslation();
  const [documentationCollapsed, setDocumentationCollapsed] = useState(false);
  const mineSiteDetails = useMemo(() => getMineSiteDetailsConfig(t, data), [t, data]);

  const {
    zoomHandler,
    zoomOutHandler,
    moveDownHandler,
    moveUpHandler,
  } = useMapHelper({ container, scl: data, t });

  return (
    <Widget
      className="with-border-header no-p-body"
      title={t('Overview')}>
      <Style>
        <div className="left-cont">
          <Widget title={t('AMP Details')} className="with-border-header widget-sm with-box-shadow">
            {mineSiteDetails.map((d, i) => (
              <div className='row-item' key={`mine-site-details-row-${i}`}>
                <label>{d.label}</label>
                {d.render()}
              </div>
            ))}
          </Widget>
        </div>

        <div className="map" ref={container} />

        <Documentation
          mode={mode}
          t={t}
          locationId="1"
          isSingleSource
          mod={mod}
          collapsed={documentationCollapsed}
          setCollapsed={setDocumentationCollapsed}
          data={data}
          isOwnData
          allSources={[]}
          className="amp-overview"
        />

        <OverviewMapControllers
          zoomHandler={zoomHandler}
          moveUpHandler={moveUpHandler}
          zoomOutHandler={zoomOutHandler}
          moveDownHandler={moveDownHandler}
          documentationCollapsed={documentationCollapsed}
        />
      </Style>
    </Widget>
  )
}
